import {Component, DestroyRef, EventEmitter, Input, Output, inject} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {distinctUntilChanged, map} from 'rxjs';
import {AuthService} from '../auth/auth.service';
import {SmInputModule} from '../shared/form-controls/sm-input/sm-input.module';
import {SmActionButtonModule} from '../shared/components/sm-action-button/sm-action-button.module';
import {TagsService} from './tags.service';
import {TagAuthor} from './tag-author';
import {TagSelection} from './tag-selection';

@Component({selector: 'sm-tag-author-filter', standalone: true, imports: [FormsModule, TranslateModule, SmInputModule, SmActionButtonModule],
 templateUrl: './tag-author-filter.component.html', styleUrl: './tag-author-filter.component.scss'})
export class TagAuthorFilterComponent {
 private static nextId = 0;
 readonly groupName = `tag-authors-${TagAuthorFilterComponent.nextId++}`;
 private appliedQuery = '';
 @Input() value: TagSelection = {authorIds: [], allAuthors: false};
 @Output() valueChange = new EventEmitter<TagSelection>();
 private readonly service = inject(TagsService);
 private readonly auth = inject(AuthService);
 private generation = 0;
 authors: TagAuthor[] = [];
 query = '';
 loading = false;
 error = false;
 more = false;
 expanded = false;
 constructor() {
  inject(DestroyRef).onDestroy(() => { this.generation++; });
  this.auth.session$.pipe(map(session => session?.user.id), distinctUntilChanged(), takeUntilDestroyed(inject(DestroyRef)))
   .subscribe(() => { this.generation++; this.authors = []; this.loading = false; this.error = false; this.more = false; this.expanded = false; this.query = ''; });
 }
 choose(mode: 'mine' | 'all'): void { this.valueChange.emit({authorIds: [], allAuthors: mode === 'all'}); }
 async open(): Promise<void> { this.expanded = !this.expanded; if (this.expanded) await this.load(); }
 async load(append = false): Promise<void> {
  if (!append) this.appliedQuery = this.query;
  const generation = ++this.generation; this.loading = true; this.error = false;
  try {
   const authors = await this.service.authors(this.appliedQuery, append ? this.authors.length : 0);
   if (generation === this.generation) { this.authors = append ? [...this.authors, ...authors] : authors; this.more = authors.length === 20; }
  } catch { if (generation === this.generation) this.error = true; }
  finally { if (generation === this.generation) this.loading = false; }
 }
 selected(id: string): boolean { return !this.value.allAuthors && this.value.authorIds.includes(id); }
 toggle(author: TagAuthor): void {
  const ids = this.value.authorIds.includes(author.id) ? this.value.authorIds.filter(id => id !== author.id) : [...this.value.authorIds, author.id];
  this.valueChange.emit({allAuthors: false, authorIds: ids});
 }
}

